export default "__VITE_ASSET__D25SftQS__"